import styled from '@emotion/styled'

export const DrawerLabel = styled.span`
  color: #4a4a68;
  font-size: 14px;
  font-weight: 500;
  line-height: 16px;
  letter-spacing: -0.02em;
`
